module.exports = __webpack_public_path__ + "img/corner-up-left.2db0e8cf.svg";